module.exports = __webpack_public_path__ + "img/lunli.0dca5eed.png";